import {ReferenceField, TextField, WrapperField} from 'react-admin';
import {ReferenceProps} from '../../models/input-field.models';
import {Box, Tooltip} from '@mui/material';
import React, {Ref} from 'react';
import {MAX_STRING_LENGTH, TextFieldTruncate} from './textFieldTruncate';
import {TypographyProps} from '@mui/material/Typography/Typography';

export const UserField = ({source, label}: ReferenceProps) => {
    return (
        <ReferenceField
            label={label}
            source={source}
            reference="v1_SystemUserBase"
            link="edit"
        >
            <TextField source="name" />
        </ReferenceField>
    );
};

export const TruncatedTitle = (
    props: TypographyProps & TextFieldTruncateProps
) => {
    const {
        source = 'new_Title',
        label = 'H1 Title',
        stringLimit = MAX_STRING_LENGTH,
    } = props;

    const TooltipTitle = React.forwardRef(
        (props: any, ref: Ref<HTMLDivElement>) => {
            return (
                <Box ref={ref} component="div">
                    <TextFieldTruncate stringLimit={stringLimit} {...props} />
                </Box>
            );
        }
    );

    return (
        <WrapperField label={label}>
            <Tooltip
                title={<TextField source={source} />}
                placement="top-start"
            >
                <TooltipTitle source={source} />
            </Tooltip>
        </WrapperField>
    );
};

export interface TextFieldTruncateProps {
    source: string;
    label: string;
    stringLimit?: number;
}
